import { Theme } from "@amx/ux-twoui-theming";
import { ILabelStyles, IStyle, IStyleFunctionOrObject, ITextFieldProps, ITextFieldStyleProps, ITextFieldStyles } from "@fluentui/react";

export const getTextFieldStyles = (theme: Theme, disabled: boolean, underlined?: boolean): ITextFieldProps["styles"] => {

    const fieldGroupStyles: IStyle = { background: theme.palette.transparent };
    if (!disabled) {
        fieldGroupStyles.backgroundColor = theme.palette.neutralHigh;
    }

    return {
        // Ensuring that the background is transparent, otherwise it inherits
        // the background colour of the root html element
        fieldGroup: fieldGroupStyles,
        suffix: {
            background: disabled ? theme.palette.neutralLighter : theme.palette.transparent,
            padding: 0,
        },
        wrapper: underlined! && {
            display: "block"
        },
        subComponentStyles: {
            label: getLabelStyles(underlined),
        }
    };
};

export const getTextFieldWithImageHiddenStyles = (theme: Theme, disabled: boolean, underlined?: boolean): IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> => {

    const styles = getTextFieldStyles(theme, disabled, underlined);

    return {
        ...styles,
        prefix:{
            display: "none"
        }
    };
};

export const getTextFieldWithImageStyles = (theme: Theme, disabled: boolean, underlined?: boolean): IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> => {

    const styles = getTextFieldStyles(theme, disabled, underlined);

    return {
        ...styles,
        field:{
            padding:"0 8px 0 0"
        },
        prefix:{
            background: disabled ? theme.palette.neutralLighter : theme.palette.transparent,
            padding:"0px 8px"
        }
    };
};

const getLabelStyles = (underlined?: boolean): ILabelStyles => ({
    root: underlined! && {
        padding: "0px",
        height: "100%"
    }
});
